import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlightWord'
})
export class HighlightWordPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null, search: string | null): SafeHtml {
    if (value && search) {
      const normalizedValue = this.normalize(value);
      const normalizedSearch = this.normalize(search);

      const re = new RegExp(normalizedSearch, 'gi');
      const matchIndices = [];
      let match;

      while ((match = re.exec(normalizedValue)) !== null) {
        matchIndices.push({ start: match.index, end: match.index + match[0].length });
      }

      let result = '';
      let lastIndex = 0;
      for (const { start, end } of matchIndices) {
        const matchedSubstring = value.slice(start, end);
        const styledSubstring = `<span style="color: #0078c0; font-weight: bold;">${matchedSubstring}</span>`;
        result += value.slice(lastIndex, start) + styledSubstring;
        lastIndex = end;
      }
      result += value.slice(lastIndex);

      // Sanitize the result to make it safe HTML
      return this.sanitizer.bypassSecurityTrustHtml(result);
    }
    return value || '';
  }

  private normalize(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
